import { Injectable } from "@angular/core";
import { AppConstants } from "app/core/app.constants";
import { BaseResponse, User } from "app/core/core.component";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";
import { Headers, Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { UserService } from "./user.service";


@Injectable()
export class GestioneUfficioService {
  private gestioneUfficioComponentStatus = new Subject<User>();
  gestioneUfficioComponentStatus$ = this.gestioneUfficioComponentStatus.asObservable();

  constructor(private http: Http) { }
  changeOffice(srmToken, user: User, uffici: string[],loginUser: String, loginPsw: String): Observable<BaseResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/users/changeOffice";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    let body = {
      username: user.username,
      uffici: uffici,
      loginPsw: loginPsw,
      loginUser: loginUser
    };
    return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
  }


  geGestioneUfficioComponentStatus(): Observable<User> {
    return this.gestioneUfficioComponentStatus.asObservable();
  }

  openGestioneUfficioComponent(user: User) {
    this.gestioneUfficioComponentStatus.next(user);
  }

  closeGestioneUfficioComponent() {    
    this.gestioneUfficioComponentStatus.next();
  }

}


// WEBPACK FOOTER //
// ./src/app/service/gestione-ufficio.service.ts